import axios from "axios";

const putSiteFile = async (
  siteFileUploadUrl: string,
  contentType: string,
  siteFile: File | Blob
): Promise<any> => {
  const { data } = await axios.put(siteFileUploadUrl, siteFile, {
    headers: {
      "Content-Type": contentType,
    },
  });
  return data;
};

export default putSiteFile;
